module.exports = __webpack_public_path__ + "static/10-964823ec9399c93da681e1ae177ac1a7.jpeg";